import { render } from "./DocumentsLegalFileCard.vue?vue&type=template&id=67f263c1&scoped=true"
import script from "./DocumentsLegalFileCard.vue?vue&type=script&lang=js"
export * from "./DocumentsLegalFileCard.vue?vue&type=script&lang=js"

import "./DocumentsLegalFileCard.vue?vue&type=style&index=0&id=67f263c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f263c1"]])

export default __exports__